// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useLocales } from "react-localized"
import logo from '../../../logo.svg'
import { Conditional, IUser, LandingPageHeading, LoginButton } from "../../../lib"
import { IonButton, IonText } from "@ionic/react"
import ReactMarkdown from "react-markdown"
import { IAccount } from "../../../api"
import { useAccount } from "../context"
import { AccountSelector } from "./AccountSelector"


interface DashboardJumbotronProps {
  accounts: {[key: number]: IAccount} | null
  user: IUser
}


const DashboardJumbotron: React.FC<DashboardJumbotronProps> = ({
  accounts,
  user
}) => {
  const {gettext} = useLocales()
  const {mustSelectAccount} = useAccount()
  const givenName: string = (!!user.isAuthenticated()) ? user.getGivenName() : ""
  const email: string = (!!user.isAuthenticated()) ? user.getEmail() : ""
  if (accounts === null) {
    return null
  }
  return (
    <div>
      <LandingPageHeading
        logo={logo}
        title={gettext`Welcome, ${givenName}`}
      />
      <IonText className="bold-primary">
        <ReactMarkdown>
          {gettext`You're signed in using the email address **${email}**.`}
        </ReactMarkdown>
      </IonText>
      <Conditional render={Object.keys(accounts).length === 0}>
        <div className="content-buttons pt-2">
          <IonButton routerLink="/accounts/create">{gettext("Create an account")}</IonButton>
          <LoginButton color="primary" fill="clear" params={{prompt: "select_account"}}>
            {gettext("Sign in with a different email address")}
          </LoginButton>
        </div>
      </Conditional>
      <Conditional render={Object.keys(accounts).length === 1}>
        <div className="content-buttons pt-2">
        </div>
      </Conditional>
      <Conditional render={Object.keys(accounts).length > 1 && mustSelectAccount}>
      </Conditional>
    </div>
  )
  
}


export {DashboardJumbotron }